import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59b98851&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=59b98851&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=59b98851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b98851",
  null
  
)

export default component.exports